import { ArchiveBoxArrowDownIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';
import { LoadingSpinner } from './LoadingSpinner.jsx';
import { useNotifications } from './context/NotificationContext/NotificationContext.jsx';
import { API } from './utils/api';

export function UpdateComponentsButton({ company_id, className = '' }) {
    const notifications = useNotifications();
    const [isUpdating, setIsUpdating] = useState(false);
    const [hasUpdated, setHasUpdated] = useState(false);
    const label = 'Update Components';

    const handleUpdateComponents = async () => {
        setIsUpdating(true);
        try {
            await API.post(`${company_id}/components/update`);
            setHasUpdated(true);
            notifications.push({
                title: 'Components update started!',
                variant: 'success',
                ttl: 10,
            });
        } catch (error) {
            notifications.push({
                title: 'Failed to update components!',
                variant: 'error',
                ttl: 20,
                error,
            });
        } finally {
            setIsUpdating(false);
        }
    };

    if (hasUpdated) return null;

    return (
        <button
            type="button"
            onClick={handleUpdateComponents}
            disabled={isUpdating}
            title={label}
            aria-label={label}
            className={[
                'rounded-full bg-white/20 p-1.5 text-white transition-all',
                'hover:bg-[#8F52F1] focus-visible:outline-none',
                'disabled:cursor-not-allowed disabled:opacity-60',
                className,
            ].join(' ')}
        >
            {isUpdating ? (
                <LoadingSpinner className="h-4 w-4" />
            ) : (
                <ArchiveBoxArrowDownIcon
                    className="h-4 w-4"
                    aria-hidden="true"
                />
            )}
        </button>
    );
}
